<div class="copo-section-header">
	<h2 mat-dialog-title class="copo-popup-title" translate>{{dialogContent.title}}</h2>
	<button type="button" mat-icon-button  class="close-icon" [mat-dialog-close]="true"><mat-icon svgIcon="md:close"></mat-icon></button>
</div>
<mat-dialog-content>
	<div class="copo-simple-dialog-content">
		<div>
			<span translate>{{dialogContent.content1}}</span>
		</div>
		<div>
			- <span translate>{{dialogContent.content2}}</span>
		</div>
		<div>
			- <span translate>{{dialogContent.content3}}</span>
		</div>
		<div>
			- <span translate>{{dialogContent.content4}}</span>
		</div>
	</div>
	<div class="copo-simple-dialog-content">
		<div>
			<span translate>{{dialogContent.content5}}</span>
		</div>
	</div>
	<div class="copo-simple-dialog-content file-upload">
		<copo-file-upload
			class="file-upload"
			#attachmentDiv
			[fileErrors]="getErrorMsg()"
			[dragAndDropLabel]="('drag.and.drop.files' | translate)"
			[orLabel]="('upload.or' | translate)"
			[browseFilesLabel]="('browse.files' | translate)"
			(filesAdded)="addAttachments($event)">
		</copo-file-upload>
	</div>
	<div class="copo-simple-dialog-content box copo-no-bottom-padding">
		<span class="card-content-label" translate>{{dialogContent.resultLabel}}</span>
		<div *ngIf="checkErrorCount()" class="copo-result">
			<div *ngFor="let error of errors">
				<span *ngIf="error.errorCode === emptyline else errorContent"><br></span>
				<ng-template #errorContent>{{error.errorCode}}</ng-template>
			</div>
		</div>
		<div *ngIf="!checkErrorCount()" class="copo-result">
			<span>{{dialogContent.result}}</span> <br>
		</div>
	</div>
</mat-dialog-content>
<mat-dialog-actions class="button-group">
	<span *ngIf="itemsInErrorCount > 0" translate>fastlane.template.upload.warning.text</span>
	<button type="button" mat-button [mat-dialog-close]="false" class="cancel-button-block">
		<span translate>filter.cancel</span>
	</button>
	<button class="btn-validate" type="submit" mat-flat-button color="primary" 
		[disabled]="(fastLaneItems.length === 0 || isValidating)" 
		(click)="validate()">
		<span translate>{{dialogContent.button}}</span>
		<mat-icon iconPositionEnd *ngIf="itemsInErrorCount > 0 && !isValidating" svgIcon="alert" matSuffix></mat-icon>
		<mat-progress-spinner *ngIf="isValidating"
				diameter="16"
				strokeWidth="2"
				color="warn"
				mode="indeterminate"
				class="spinner-icon"
			>
		</mat-progress-spinner>
	</button>
</mat-dialog-actions>